import React from "react";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../store/actions/assetActions";
import { format, addMonths, lastDayOfMonth } from "date-fns";
import Tooltip from "@/tooltip";

import { Link } from "react-router-dom";

import { ClipboardIcon, PencilSquareIcon } from "@heroicons/react/20/solid";
import { copyToClipboard } from "@/helpers/ClipboardHelpers";

export const AssetRow = ({ asset, isAdmin, clearAsset }) => {
	return (
		<tr>
			<td>
				<Link
					className="btn btn-xs btn-default"
					type="button"
					to={`/organisation/asset/${asset.id}`}
					style={{ marginLeft: 10, marginRight: 10 }}
					onClick={() => clearAsset()}
				>
					<Tooltip content="Edit Asset">
						<PencilSquareIcon
							className="h-5 w-5"
							style={{ marginTop: "3px" }}
						/>
					</Tooltip>
				</Link>
				{isAdmin && (
					<div
						className="btn btn-xs btn-default"
						type="button"
						onClick={() => copyToClipboard(asset.id)}
						style={{ marginRight: 10 }}
					>
						<ClipboardIcon
							className="h-5 w-5 text-dark-gray"
							style={{ marginTop: "3px" }}
						/>
					</div>
				)}
			</td>
			<td>{asset.name || ""}</td>
			<td>{asset.reference}</td>
			<td>{asset.type || ""}</td>
			<td>{asset.subType || ""}</td>
			<td>{asset.employeeName}</td>
			<td></td>
		</tr>
	);
};

const mapStateToProps = (state, ownProps) => {

  return {
    isAdmin: state?.my?.profile?.isAdmin
  };
};

const mapDispatchToProps = (dispatch) => ({
  setOpenModal: (status, leave) => dispatch(ACTIONS.setOpenModal(status, leave)),
  clearAsset: () => dispatch(ACTIONS.clearAsset()),
  saveLeave: (leave) => dispatch(ACTIONS.saveLeave(leave)),
  showCancelLeave: (leave, status) =>
    dispatch(ACTIONS.showCancelLeave(leave, status)),
  showComments: (leave) => dispatch(ACTIONS.showComments(leave)),
  showAttachments: (leave) => dispatch(ACTIONS.showAttachments(leave)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AssetRow);
